import * as React from "react";
import Header from "./Header";
import Footer from "./Footer";
import {AppIcon} from "../../Config";
// import CovidInfoButton from "../../modules/infoCovid/CovidInfoButton";

interface Props {
    currentRoute: string,
    children: React.ReactNode;
}

interface State {
    visibleArrowTop: boolean
}

export default class Screen extends React.Component<Props, State> {

    private containerRef: any = null;

    public constructor(props: Props) {
        super(props);
        this.state = {visibleArrowTop: false};
    }

    public componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    public componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    public render(): React.ReactNode {
        const {currentRoute, children} = this.props;
        const {visibleArrowTop} = this.state;

        return (
            <>
                <div className={'screen-container'} ref={(ref: HTMLDivElement | null) => this.containerRef = ref}>
                    <Header currentRoute={currentRoute}/>

                    {/* información para covid, eliminar cuando ya no sea necesario */}
                    {/* <CovidInfoButton/> */}

                    <section id={'section-scroll'}>

                        {visibleArrowTop &&
                        <div className={"scroll-top"} onClick={this.handleScrollTop}>
                            <i className={AppIcon.ARROW_TOP}/>
                        </div>}

                        {children}

                    </section>

                </div>

                <Footer/>
            </>
        )
    }

    private handleScrollTop = (): void => {
        window.scrollTo(0, this.containerRef.offsetTop);
        this.setHideArrowTop();
    }

    private setShowArrowTop = (): void => {
        this.setState({visibleArrowTop: true});
    }

    private setHideArrowTop = (): void => {
        this.setState({visibleArrowTop: false});
    }

    private handleScroll = (): void => {
        const headerElement = document.getElementById('section-scroll');
        if (headerElement) {
            if (window.scrollY) {
                const isAtTheTopOfPage = document.getElementsByClassName('small-header');
                if (isAtTheTopOfPage.length !== 0) {
                    this.setShowArrowTop();
                } else {
                    this.setHideArrowTop();
                }
            }
        }
    }
}